export const APPLICATION_ID = '10107'
